import { NumericFormat, NumericFormatProps } from "react-number-format";
import { felixTokens } from "../../../../theme";

export default function InteiroText(props: NumericFormatProps) {
  const { ...other } = props;

  return (
    <NumericFormat
      decimalScale={0}
      displayType={"text"}
      thousandSeparator="."
      decimalSeparator=","
      fixedDecimalScale
      valueIsNumericString
      // Quantidade também é número em coluna: mono tabular.
      style={{
        fontFamily: felixTokens.fontMono,
        fontVariantNumeric: "tabular-nums",
      }}
      {...other}
    />
  );
}
